import React from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Button } from 'primereact/button';
import logoImage from 'assets/img/app.png';

// Função auxiliar para converter a imagem em Base64
const getBase64ImageFromUrl = async (imageUrl) => {
  try {
    const res = await fetch(imageUrl, { cache: "no-cache" });
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Erro ao converter imagem:", error);
    return null;
  }
};

function ExportPontos({ listaDados, pessoal }) {
  const gerarPdf = async () => {
    // Cria um documento A4 em retrato (p) com medidas em milímetros (mm)
    const doc = new jsPDF('p', 'mm', 'a4');
    let currentY = 8; // margem superior

    // Converte e adiciona a logo
    const logoBase64 = await getBase64ImageFromUrl(logoImage);
    if (logoBase64) {
      // Insere a logo no canto superior esquerdo (x: 14, y: 10, width: 40, height: 20)
      doc.addImage(logoBase64, 'PNG', 160, currentY, 40, 40);
    } else {
      console.warn("Logo não carregada, continuando sem ela.");
    }

    // Cabeçalho com informações do relatório e do funcionário
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("Relatório de Pontos", 14, currentY + 12);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`Funcionário: ${pessoal.nome}`, 14, currentY + 20);
    doc.text(`Base: ${pessoal.base[0].nome || 'N/A'}`, 14, currentY + 28);
    doc.text(`CPF: ${pessoal.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") || 'N/A'}`, 14, currentY + 36);

    

    // Define as colunas da tabela e prepara os dados
    const colunas = ["Data", "Hora Início", "Hora Almoço", "Hora Pausa", "Hora Fim", "Total"];
    const linhas = listaDados.map(item => [
      item.date,
      item.hour_first || '-',
      item.hour_dinner || '-',
      item.hour_stop || '-',
      item.hour_finish || '-',
      item.worked_hours || '-'
    ]);

    // Insere a tabela a partir de uma posição abaixo do cabeçalho
    const startY = currentY + 39;
    doc.autoTable({
      head: [colunas],
      body: linhas,
      startY: startY,
      theme: 'striped',
      headStyles: { fillColor: [41, 128, 185] },
      styles: { font: "helvetica", fontSize: 12, cellPadding: 1, fontStyle: 'bold' },
    });

    // Área para assinatura (posicionada abaixo da tabela)
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(18);
    doc.text("Ass: ________________________________________________", 14, finalY);

    // Rodapé com a data de emissão
    const hoje = new Date().toLocaleDateString();
    doc.setFontSize(10);
    doc.text(`Emitido em: ${hoje}`, 14, 5);

    // Salva e baixa o PDF, substituindo espaços no nome por underlines
    doc.save(`${pessoal.nome.replace(/\s+/g, '_')}_Relatorio.pdf`);
  };

  return (
    <div>
      <Button
        label="Exportar para ficha PDF"
        icon="pi pi-file-pdf"
        className="bg-lightBlue-600 mx-4 text-white px-3 py-3 rounded-md shadow hover:bg-lightBlue-500"
        onClick={gerarPdf}
      />
    </div>
  );
}

export default ExportPontos;
